import PrivacyPolicyScreen from './(onboarding)/privacy-policy';

export default PrivacyPolicyScreen;


